import React from 'react';
import './Message.css';
import ReactEmoji from 'react-emoji'
const Message = ({message:{text,user},name}) => {
    let isSetByCurrentUser = false;
    const trimmedName = name.trim().toLowerCase();
    if(user===trimmedName){
        isSetByCurrentUser=true;
    }

    return (
        isSetByCurrentUser?(
        <div className="messageContainer justifyEnd">
            <p className="sentText pr-10">you</p>
            <div className="messageBox backgroundBlue">
                <p className="messageText colorWhite">{ReactEmoji.emojify(text)}</p>
            </div>
        </div>
        ):
        (user==="admin")?
        (
            <div className="messageContainer justifyCenter">
                {/* <p className="sentText pr-10">{user}</p> */}
                <div className="messageBox noBackground">
                    <p className="messageText colorGray">{ReactEmoji.emojify(text)}</p>
                </div>
            </div>
        ):
        (
            <div className="messageContainer justifyStart">
            <div className="messageBox backgroundWhite">
                <p className="messageText colorDark">{ReactEmoji.emojify(text)}</p>
            </div>
            <p className="sentText pl-10">{user}</p>
        </div>
        )
        )
};

export default Message;